import { defineComponent } from 'vue';
export const dropDownChildBase = defineComponent({
    props: {
        dropDownParent: {
            type: Object,
            default: {},
        },
    },
});
